import { memo } from "react";

import GhostEnvironmentConnectedDestination from "./ConnectedDestination";

// -----------------------------------------------------------------------------

const GhostEnvironmentConnectedSources = memo(
  function GhostEnvironmentConnectedSources() {
    return (
      <>
        <GhostEnvironmentConnectedDestination />
        <GhostEnvironmentConnectedDestination />
        <GhostEnvironmentConnectedDestination />
        <GhostEnvironmentConnectedDestination />
      </>
    );
  }
);

export default GhostEnvironmentConnectedSources;
